export interface Time {
  hours: number
  minutes: number
  seconds: number
}

export function totalSeconds(minutes: number, seconds: number): number {
  return minutes * 60 + seconds
}

export function toTime(timeInSeconds: number): Time {
  const totalSeconds = Math.floor(timeInSeconds)
  const secondsPerMinute = 60
  const minutesPerHour = 60
  const totalMinutes = Math.floor(totalSeconds / secondsPerMinute)
  const totalHours = Math.floor(totalMinutes / minutesPerHour)
  const remainingSeconds = totalSeconds % secondsPerMinute
  const remainingMinutes = totalMinutes % minutesPerHour
  return {
    hours: totalHours,
    minutes: remainingMinutes,
    seconds: remainingSeconds
  }
}

export function formatTime(timeInSeconds: number): string {
  const time = toTime(timeInSeconds)
  const formattedHours =
    time.hours > 0 ? time.hours.toString().padStart(2, '0') + ':' : ''
  const formattedMinutes = time.minutes.toString().padStart(2, '0')
  const formattedSeconds = time.seconds.toString().padStart(2, '0')
  return `${formattedHours}${formattedMinutes}:${formattedSeconds}`
}

export function parseTime(formattedTime: string): number {
  const [mm, ss] = formattedTime.split(':')
  const minutes = Number.parseInt(mm)
  const seconds = Number.parseInt(ss)

  return totalSeconds(minutes, seconds)
}

export default formatTime
